// Badge styles

import styled, { css } from 'styled-components';

export const BadgeStyled = styled.small`
  font-size: ${props => props.theme.font.size[props.size]};
  font-weight: ${props => props.theme.font.weight.xbold};
  color: ${props =>
    props.url
      ? props.theme.color.wfGrey900
      : props.customBgColor
      ? props.theme.color.wfWhite
      : props.theme.color.wfGrey900};
  border-radius: ${props => props.theme.borderRadius.large};
  background-color: ${props =>
    props.customBgColor ? props.customBgColor : props.theme.color.wfGrey200};
  padding: 0.5em 1em;
  display: inline-block;
  line-height: 1;
  transition: border-color ease 0.1s;
  &:hover {
    ${props =>
      props.url &&
      css`
        background-color: ${props.theme.color.wfGrey300};
        cursor: pointer;
      `}
  }
`;
